import {Show} from 'platform/foundation';

import {featureFlags} from '@dms/feature-flags';

import {ShowWhen} from './primitives/ShowWhen';
import {SimpleTextField} from './SimpleTextField';

/**
 * German-specific vehicle registration fields (HSN, TSN, Baureihe)
 * Simple component that renders the registration number fields
 */
export function GermanSpecificFields() {
  return (
    <>
      <SimpleTextField name="hsn" />
      <SimpleTextField name="tsn" />
      <Show whenFeatureEnabled={featureFlags.ADVERTISEMENT_PER_PLATFORM_ATTRIBUTES}>
        <ShowWhen
          name="type"
          condition={(type) =>
            (type?.at(0) ?? 'VEHICLETYPE_PASSENGER_CAR') === 'VEHICLETYPE_PASSENGER_CAR'
          }
        >
          <SimpleTextField name="modelRange" />
        </ShowWhen>
      </Show>
    </>
  );
}
